/*jslint nomen: true, vars: true, white: true */
/*jshint scripturl: true */
/*global interstate,esprima,able,uid,console,window,jQuery,Raphael */

(function (ist, $) {
	"use strict";
	var cjs = ist.cjs,
		_ = ist._;

	cjs.registerCustomPartial("col", {
		createNode: function(options) {
			return $("<table />").column(options);
		},
		destroyNode: function(node) {
			$(node).column("destroy");
		}
	});

	var column_template = cjs.createTemplate(
		"<tbody>" +
			"<tr class='header'>" +
				"<th colspan={{num_curr_values+1}} class='obj_name'>" +
					"{{#if pinned && !is_root}}" +
						"<button type='button' title='Previous' aria-label='Previous object' data-cjs-on-click='prev_col' class='prev_btn glyphicon glyphicon-chevron-left'></button>" +
					"{{/if}}" +
					"<h2 data-cjs-on-mouseover='headerMOver' data-cjs-on-mouseout='headerMOut' data-cjs-on-click='headerClicked'>" +
						// (a button, so that the keyboard can come back to this object)
						"<button type='button' class='obj_name_label' data-cjs-on-focus='headerMOver' data-cjs-on-blur='headerMOut'>" +
							"{{ci}}{{name}}" +
							"{{#if is_template}}" +
								"[{{curr_copy_index}}]" +
							"{{/if}}" +
						"</button>" +
					"</h2>" +
					"{{#if pinned}}" +
						"<button type='button' title='Close' aria-label='Close' data-cjs-on-click='close_col' class='close_btn glyphicon glyphicon-remove'></button>" +
					"{{/if}}" +
				"</th>" +
				"{{#if stateful}}" +
					"<th rowspan='{{is_template ? 4 : 3}}' class='statechart_cell'>" +
						"{{#if is_curr_col}}" +
							"{{statechart_view}}" +
						"{{/if}}" +
					"</th>" +
				"{{#else}}" +
					"<th rowspan='2'></th>" +
				"{{/if}}" +
			"</tr>" +

			"{{#if is_curr_col}}" +
				"{{#if stateful}}" +
					"<tr class='copies_spec'>" +
						"<td colspan='{{num_curr_values+1}}' class='copies_spec'>" +
							"<span class='copies_label'>Copies: </span>" +
							"{{> propCell getCopiesCellOptions() }}" +
						"</td>" +
					"</tr>" +
				"{{/if}}" +

				"<tr class='add_prop'>" +
					"<td colspan='{{num_curr_values+1}}' class='add_prop'>" +
						"<button type='button' class='add_prop' data-cjs-on-click=addProperty>Add Field</button>" +
					"</td>" +
				"</tr>" +
				"{{#if is_template}}" +
					"<tr class='switch_copy'>" +
						"<td></td>" +
						"{{#if show_prev_value}}" +
							"<td class='prev_copy' data-cjs-on-mouseover='prevMOver' data-cjs-on-mouseout='prevMOut' data-cjs-on-click='selectPrevClient'>" +
								"<button type='button' aria-label='Previous copy' class='glyphicon glyphicon-chevron-left'></button>" +
							"</td>" +
						"{{/if}}" +
						"<td class='curr_copy' aria-live='polite' data-cjs-on-mouseover='currMOver' data-cjs-on-mouseout='currMOut'>" +
							"copy {{curr_copy_index+1}} of {{num_instances}}" +
						"</td>" +
						"{{#if show_next_value}}" +
							"<td class='next_copy' data-cjs-on-mouseover='nextMOver' data-cjs-on-mouseout='nextMOut' data-cjs-on-click='selectNextClient'>" +
								"<button type='button' aria-label='Next copy' class='glyphicon glyphicon-chevron-right'></button>" +
							"</td>" +
						"{{/if}}" +
					"</tr>" +
				"{{/if}}" +
			"{{/if}}" +
			"{{#each builtins}}" +
				"{{>prop getPropertyViewOptions(this, true)}}" +
			"{{/each}}" +

			"{{#if adding_field&&is_curr_col}}" +
				"<tr class='new_field'>" +
					"<td class='name'><input placeholder='Field name' aria-label='Field name' class='name' /></td>" +
					"<td class='type'>" +
						"<select class='type' aria-label='Field type'>" + 
							"<option value='stateful'>Object</option>" +
							"<option value='stateful_prop'>Property</option>" +
						"</select>" + 
					"</td>" +
					"<td class='confirm_field'>" +
						"<button type='button' class='confirm_field'>OK</button>" +
					"</td>" +
				"</tr>" +
			"{{/if}}" +

			"{{#each children}}" +
				"{{>prop getPropertyViewOptions(this)}}" +
				"{{#else}}" +
					"{{#if !adding_field && builtins.length===0}}" +
						"<tr class='no_children'>" +
							"<td colspan='{{num_curr_values+2}}'>No fields</td>" +
						"</tr>" +
					"{{/if}}" +
			"{{/each}}" +
		"</tbody>"
		);

	$.widget("interstate.column", {
		options: {
			client: false,
			prev_col: false,
			show_prev: false,
			is_curr_col: false,
			show_source: true,
			curr_copy_client: false,
			client_socket: false,
			selected_prop_name: false,
			curr_copy_index: false,
			close_button: false,
			columns: false,
			column_index: -1,
			editor: false,
			pinned: false
		},

		_create: function() {
			var client = this.option("client");
			client.signal_interest();

			this.element.attr("draggable", true);
			this.$dragging = this.option("editor").getDraggingClientConstraint();

			var root_client = this.option("editor").root_client; 
			this.is_root = client === root_client;
			
			this.$adding_field = cjs(false);
			if(this.option("pinned")) {
				this.$selected_prop = cjs.constraint(false);
			} else {
				this.$selected_prop = this.option("columns").itemConstraint(this.option("column_index")+1);
			}

			this.$is_curr_col = this.option("is_curr_col");

			this.$name = client.get_$("get_name");
			this.$copies_obj = client.get_$("copies_obj");
			this.$is_template = client.get_$("is_template");
			this.$instances = client.get_$("instances");

			this.$num_instances = this.$instances.prop("length");

			this.$curr_copy_index = cjs(0);
			this.$curr_copy_client = cjs(function() {
				if(this.$is_template.get()) {
					var instances = this.$instances.get(),
						curr_copy_index = this.$curr_copy_index.get();
					if(instances[curr_copy_index]) {
						return instances[curr_copy_index];
					} else {
						return false;
					}
				} else {
					return client;
				}
			}, {context: this});

			this.$prev_copy_client = cjs(function() {
				if(this.$is_template.get()) {
					var instances = this.$instances.get(),
						copy_index = this.$curr_copy_index.get()-1;
					if(instances[copy_index]) {
						return instances[copy_index];
					}
				}

				return false;
			}, {context: this});

			this.$next_copy_client = cjs(function() {
				if(this.$is_template.get()) {
					var instances = this.$instances.get(),
						copy_index = this.$curr_copy_index.get()+1;
					if(instances[copy_index]) {
						return instances[copy_index];
					}
				}

				return false;
			}, {context: this});

			this.$show_prev_value = cjs(this.$prev_copy_client);
			this.$show_next_value = cjs(this.$next_copy_client);

			this.$num_curr_values = this.$is_template.iif(this.$prev_copy_client.iif(2,1).add(this.$next_copy_client.iif(1,0)), 1);

			this.$column_info = ist.indirectClient(this.$curr_copy_client, ["children", true], "builtin_children");
			this.$children = this.$column_info.itemConstraint("children");
			this.$builtins = this.$column_info.itemConstraint("builtin_children");

			if(client.type() === "stateful") {
				this.$statecharts = ist.indirectClient(this.$curr_copy_client, "get_statecharts");

				var statecharts = [], wrappers = [], wrapper_infos = [];

				this.statechart_view = $("<div />")	.statechart({
														statecharts: statecharts,
														client: this.$curr_copy_client
													});

				this.layout_manager = this.statechart_view.statechart("get_layout_manager");

				this.sc_live_fn = cjs.liven(function() {
					var old_wrapper_infos = wrapper_infos;
					wrapper_infos = this.$statecharts.get() || [];
					var diff = _.diff(old_wrapper_infos, wrapper_infos, function(a, b) {
						return a.object_summary.id === b.object_summary.id;
					});
					_.forEach(diff.removed, function (info) {
						var index = info.from, child = info.from_item;

						var wrapper = wrappers[index];
						var statechart = statecharts[index];

						wrapper.signal_destroy();

						wrappers.splice(index, 1);
						statecharts.splice(index, 1);
						//statechart.destroy();
					}, this);
					_.forEach(diff.added, function (info) {
						var index = info.to, child = info.item;
						var wrapper = child;
						var statechart = ist.create_remote_statechart(wrapper);
						wrappers.splice(index, 0, wrapper);
						wrapper.signal_interest();
						statecharts.splice(index, 0, statechart);
					}, this);
					_.forEach(diff.moved, function (info) {
						var from_index = info.from, to_index = info.to, child = info.item;

						//var wrapper = wrappers[from_index];
						var statechart = statecharts[from_index];
						//wrapper.splice(from_index, 1);
						//wrappers.splice(to_index, 0, wrapper);
						statecharts.splice(from_index, 1);
						statecharts.splice(to_index, 0, statechart);
					}, this);
					if(diff.added.length > 0 || diff.removed.length > 0 || diff.moved.length > 0) {
						this.statechart_view.statechart("option", "statecharts", statecharts);
					}
				}, {
					context: this,
					on_destroy: function() {
						_.each(wrappers, function(wrapper) {
							wrapper.signal_destroy();
						});
					}
				});
			}

			this._add_content_bindings();
			this._add_class_bindings();

			this.element.on("expand.on_child_select", _.bind(this.on_child_select, this))
						.on("contextmenu.header_menu", ".obj_name_label", _.bind(this.show_header_menu, this))
						.on("keydown.header_menu", ".obj_name_label", _.bind(function(event) {
							if(ist.keyboard.is_menu_key(event)) {
								event.preventDefault();
								event.stopPropagation();
								this.show_header_menu();
							}
						}, this));
		},
		_destroy: function() {
			var client = this.option("client");

			this.hide_header_menu();
			this.element.off(".header_menu .on_child_select");
			this._remove_class_bindings();
			this._remove_content_bindings();

			if(this.$statecharts) {
				this.statechart_view.statechart("destroy");
				this.sc_live_fn.destroy();
				this.$statecharts.destroy();
			}

			this.$curr_copy_client.destroy();
			this.$prev_copy_client.destroy();
			this.$next_copy_client.destroy();
			this.$is_template.signal_destroy();
			this.$is_curr_col.destroy();
			this.$name.signal_destroy();
			this.$instances.signal_destroy();
			this.$copies_obj.signal_destroy();
			this.$children.destroy();
			this.$builtins.destroy();

			this.$column_info.destroy();

			client.signal_destroy();

			this._super();
		},

		_add_content_bindings: function() {
			var client = this.option("client");
			column_template({
				name: this.$name,
				children: this.$children,
				builtins: this.$builtins,
				stateful: client.type() === "stateful",
				is_template: this.$is_template,
				getPropertyViewOptions: _.bind(function(child) {
					return {
						client: child.value,
						name: child.name,
						inherited: child.inherited,
						builtin: child.builtin,
						layout_manager: this.layout_manager,
						show_src: this.$is_curr_col,
						obj: this.option("client"),
						client_socket: this.option("client_socket"),
						statechart_view: this.statechart_view,
						selected: this.$selected_prop.eqStrict(child.value),
						prev: this.$prev_copy_client,
						next: this.$next_copy_client,
						editor: this.option("editor")
					};
				}, this),
				statechart_view: this.statechart_view,
				is_curr_col: this.$is_curr_col,
				headerClicked: _.bind(this.on_header_click, this),
				close_col: _.bind(this.close_col, this),
				prev_col: _.bind(this.prev_col, this),
				addProperty: _.bind(this._add_property, this),
				adding_field: this.$adding_field,
				getCopiesCellOptions: _.bind(function() {
					return {
						client: cjs.constraint(this.$copies_obj)
					};
				}, this),
				num_curr_values: this.$num_curr_values,
				curr_copy_index: this.$curr_copy_index,
				show_prev_value: this.$show_prev_value,
				show_next_value: this.$show_next_value,
				selectPrevClient: _.bind(function() {
					this.$curr_copy_index.set(this.$curr_copy_index.get() - 1);
				}, this),
				selectNextClient: _.bind(function() {
					this.$curr_copy_index.set(this.$curr_copy_index.get() + 1);
				}, this),
				num_instances: this.$num_instances,
				pinned: this.option("pinned"),
				is_root: this.is_root,
				headerMOver: _.bind(function() {
					var copy_client = this.$curr_copy_client.get(),
						event = new $.Event("add_highlight");
					event.client = copy_client;
					this.element.trigger(event);
				}, this),
				headerMOut: _.bind(function() {
					var copy_client = this.$curr_copy_client.get(),
						event = new $.Event("remove_highlight");
					event.client = copy_client;
					this.element.trigger(event);
				}, this),
				prevMOver: _.bind(function() {
					var copy_client = this.$prev_copy_client.get(),
						event = new $.Event("add_highlight");
					event.client = copy_client;
					this.element.trigger(event);
				}, this),
				prevMOut: _.bind(function() {
					var copy_client = this.$prev_copy_client.get(),
						event = new $.Event("remove_highlight");
					event.client = copy_client;
					this.element.trigger(event);
				}, this),
				nextMOver: _.bind(function() {
					var copy_client = this.$next_copy_client.get(),
						event = new $.Event("add_highlight");
					event.client = copy_client;
					this.element.trigger(event);
				}, this),
				nextMOut: _.bind(function() {
					var copy_client = this.$next_copy_client.get(),
						event = new $.Event("remove_highlight");
					event.client = copy_client;
					this.element.trigger(event);
				}, this),
				currMOver: _.bind(function() {
					var copy_client = this.$curr_copy_client.get(),
						event = new $.Event("add_highlight");
					event.client = copy_client;
					this.element.trigger(event);
				}, this),
				currMOut: _.bind(function() {
					var copy_client = this.$curr_copy_client.get(),
						event = new $.Event("remove_highlight");
					event.client = copy_client;
					this.element.trigger(event);
				}, this)
			}, this.element);
			this._select_just_added_name = cjs.liven(function() {
				var children = this.$children.get();
				if(this._just_added_prop_name) {
					var child;
					for(var i = 0; i<children.length; i++) {
						child = children[i];
						if(child.name === this._just_added_prop_name) {
							this._trigger_child_select(child.value);
							delete this._just_added_prop_name;
							_.defer(_.bind(this.focus_prop, this, child.name));
							return;
						}
					}
				}
			}, {
				context: this
			});
		},

		_remove_content_bindings: function() {
			cjs.destroyTemplate(this.element);
		},

		_add_class_bindings: function() {
			this._class_binding = cjs.bindClass(this.element, "col",
									this.$is_curr_col.iif("curr_col"),
									this.$is_template.iif("template"));
			// (Screen readers call the object's table by its name)
			this._label_binding = cjs.bindAttr(this.element, "aria-label", this.$name);
		},

		_remove_class_bindings: function() {
			this._class_binding.destroy();
			this._label_binding.destroy();
		},

		_setOption: function(key, value) {
			this._super(key, value);
			if(key === "is_curr_col") {
				this.$is_curr_col.set(value);
			}
		},

		// What dragging the column does: pin it, or save it as a component
		show_header_menu: function(event) {
			if(event) {
				event.preventDefault();
				event.stopPropagation();
			}
			this.hide_header_menu();
			var label = $(".obj_name_label", this.element).first(),
				client = this.option("client"),
				menu = $("<ul class='menu header_menu' />")	.css({ left: 0, top: "100%" })
															.appendTo(label.closest("th"));
			if(!this.option("pinned")) {
				$("<li class='menu-item' />").text("Pin").appendTo(menu).on("click", _.bind(function() {
					this.hide_header_menu();
					$("#pinned").pinned("addClient", client);
					ist.keyboard.announce("Pinned " + label.text());
				}, this));
			}
			$("<li class='menu-item' />").text("Save as component").appendTo(menu).on("click", _.bind(function() {
				this.hide_header_menu();
				this.option("client_socket").post({
					type: "save_component",
					cobj_id: client.cobj_id
				});
				ist.keyboard.announce("Saved " + label.text() + " as a component");
			}, this));
			this._header_menu = menu;
			$(window).on("mousedown.header_menu", _.bind(function(e) {
				if(!$(e.target).closest(menu).length) {
					this.hide_header_menu();
				}
			}, this));
			ist.keyboard.menu(menu, {
				items: "> li",
				close: _.bind(this.hide_header_menu, this),
				return_focus: label
			});
		},
		hide_header_menu: function() {
			if(this._header_menu) {
				this._header_menu.remove();
				delete this._header_menu;
			}
			$(window).off("mousedown.header_menu");
		},
		close_col: function(event) {
			event.stopPropagation();
			event.preventDefault();

			var e = new $.Event("close_column");
			this.element.trigger(e);
		},
		prev_col: function(event) {
			event.stopPropagation();
			event.preventDefault();

			var e = new $.Event("prev_column");
			this.element.trigger(e);
		},
		on_header_click: function(event) {
			this.element.trigger("header_click", this.option("client"));
			event.stopPropagation();
			event.preventDefault();
		},
		on_child_select: function(event) {
			if(event && $(event.target).hasClass("selected")) {
				this.on_header_click(event);
			} else {
				var target = $(event.target),
					client = target.data("interstate-prop") ? target.prop("option", "client"): false;
				this._trigger_child_select(client);
			}
		},
		_trigger_child_select: function(client) {
			this.element.trigger("child_select", client);
		},
		// The row of the field called `name`
		get_prop_row: function(name) {
			return this.element.children("tbody").children("tr.child").filter(function() {
				var prop = $(this).data("interstate-prop");
				return prop && prop.option("name") === name;
			}).first();
		},
		focus_prop: function(name) {
			$(".prop_label", this.get_prop_row(name)).focus();
		},
		_add_property: function() {
			var child_names = _.pluck(this.$children.get(), "name"),
				default_name = "field_"+(child_names.length+1),
				name = default_name,
				i = 1,
				client = this.option("client");
				
			while(child_names.indexOf(name) >= 0) {
				name = default_name + "_" + i;
				i++;
			}

			this.$adding_field.set(true);
			if(client.type() === "stateful") {
				$("select.type", this.element).val("stateful_prop");
			} else {
				$("select.type", this.element).val("stateful");
			}

			$('.new_field input.name', this.element).val(name)
												.select()
												.focus();
			var trigger_add_prop = _.bind(function() {
					$('select.type,input,button.confirm_field', this.element).off('.addfield');
					clearTimeout(onFormBlur);

					var event = new $.Event("command");
					event.command_type = "add_property";
					event.client = this.option("client");
					this._just_added_prop_name = event.prop_name = $('.new_field input.name', this.element).val();
					window.setTimeout(_.bind(function() {
						delete this._just_added_prop_name;
					}, this), 200);
					event.prop_type = $('select.type', this.element).val();

					this.element.trigger(event);

					this.$adding_field.set(false);
				}, this),
				cancel_add_prop = _.bind(function() {
					$('select.type,input,button.confirm_field', this.element).off('.addfield');
					this.$adding_field.set(false);
					$("button.add_prop", this.element).focus();
				}, this);
			var onFormBlur;
			$('button.confirm_field', this.element).on('click.addfield', function(e) {
				e.preventDefault();
				e.stopPropagation();
				trigger_add_prop();
			});
			$('select.type,input,button.confirm_field', this.element).on('blur.addfield', function(e) {
				e.preventDefault();
				e.stopPropagation();
				onFormBlur = setTimeout(function() {
					trigger_add_prop();
				}, 50);
			}).on('focus.addfield', function() {
				clearTimeout(onFormBlur);
			}).on('keydown.addfield', function(event) {
				if(event.keyCode === 13) { // enter
					trigger_add_prop();
				} else if(event.keyCode === 27) { //esc
					cancel_add_prop();
				}
			});
		},
	});
}(interstate, jQuery));
